import { useContext } from 'react'
import { StoreContext } from '../contexts/StoreProvider';

const useAsyncCallWithLoader = (backendCall) => {
  const [state, dispatch] = useContext(StoreContext);
  
  const apiCallWithLoaderFn = async (...params) => {
    dispatch({type: 'show-loader'});
    const res = await backendCall(...params);
    dispatch({type: 'hide-loader'});
    return res;
  }

  return apiCallWithLoaderFn
}

export default useAsyncCallWithLoader;